(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
    if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', function(){
            if(event.target.classList.contains('swiper-slide')){
                const collectionListSwiperEl = event.target.closest('.swiper.collection-list-slider');
                let slideIndex = event.target.dataset.index;
                if(collectionListSwiperEl){
                    collectionListSwiperEl.swiper.slideTo(slideIndex);
                }
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    

    if (!Shopify.designMode){
         if (!localStorage.getItem('popupDisplayed')) {
            setTimeout(function(){
                popupShow()
                localStorage.setItem('popupDisplayed', true);
            }, 5000)
        }
        const newsletterPopup = document.getElementById('newsletter-popup');
        const popupCloseBtn = newsletterPopup.querySelector('.popup-close');
        const popupCancelBtn = newsletterPopup.querySelector('.popup-cancel');
        popupCloseBtn.addEventListener('click', function(){
            popupClose()
        });
        popupCancelBtn.addEventListener('click', function(){
            popupClose()
        });
        document.addEventListener('click', function(event) {
            const popupCard = newsletterPopup.querySelector('.popup-card');
            if (!popupCard.contains(event.target)) {
                popupClose();
            }
        });
        document.addEventListener("DOMContentLoaded", function() {
            if (window.location.hash === '#popupContactForm') {
                popupShow();
            }
        });
    }

    if(Shopify.designMode){
        document.addEventListener('shopify:section:select', function(){
            const sectionSelected = event.target.classList.contains('popup-section');
            if(sectionSelected){
              popupShow();
            }else{
                popupClose();
            }
        })
    }

    function popupShow() {
        const htmlEl = document.querySelector('html');
        const newsletterPopup = document.getElementById('newsletter-popup');
        const popupCard = newsletterPopup.querySelector('.popup-card');
        newsletterPopup.classList.add('show');
        htmlEl.classList.add('popup-show');
        if(Shopify.designMode){
            newsletterPopup.classList.add('fade');
        }
        setTimeout(function() {
            newsletterPopup.classList.add('fade');
            if(!Shopify.designMode){
                popupCard.focus();
            }
        }, 100);

        // Trap focus within the popup card
        popupCard.setAttribute('tabindex', '-1');
        popupCard.addEventListener('keydown', function(event) {
            trapFocus(event, popupCard);
        });
    }

    function popupClose() {
        const htmlEl = document.querySelector('html');
        const newsletterPopup = document.getElementById('newsletter-popup');
        newsletterPopup.classList.remove('fade');
        setTimeout(function() {
            newsletterPopup.classList.remove('show');
            htmlEl.classList.remove('popup-show');
        }, 400);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.handleIntersection = this.handleIntersection.bind(this);
      this.recommendationSectionSlider = this.recommendationSectionSlider.bind(this);
      this.intersectionCompleted = false;
    }

    connectedCallback() {
      this.intersectionObserver = new IntersectionObserver(
        this.handleIntersection,
        { rootMargin: '0px 0px 200px 0px' }
      );
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      const url = this.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          this.intersectionCompleted = true; // Set the flag to true after completion
          if(html.querySelector('.recommendation-list-slider')){
            this.recommendationSectionSlider();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
    recommendationSectionSlider(){
        if (!this.intersectionCompleted) return;
        const featureSlider = this.querySelector('.recommendation-list-slider');
        const section = '#' + featureSlider.id;
        const prevBtn = featureSlider.closest('product-recommendations').querySelector('.slider-btn-prev');
        const nextBtn = featureSlider.closest('product-recommendations').querySelector('.slider-btn-next');
        const dtSlides = featureSlider.dataset.desktopSlides;
        const sdtSlides = featureSlider.dataset.smalldesktopSlides;
        const ltSlides = featureSlider.dataset.laptopSlides;
        const tbSlides = featureSlider.dataset.tabletSlides;
        const mbSlides = featureSlider.dataset.mobileSlides;
        this.recommendationListSlider(section, prevBtn, nextBtn, dtSlides, sdtSlides, ltSlides, tbSlides, mbSlides);
    }
    recommendationListSlider(section, prevBtn, nextBtn, dtSlides, sdtSlides, ltSlides, tbSlides, mbSlides) {
        try {
          let swiper = new Swiper(section, {
                spaceBetween: 20,
                slidesPerView: mbSlides,
                allowTouchMove: true,
                navigation: {
                  prevEl: prevBtn,
                  nextEl: nextBtn
                },
                clickable: true,
                breakpoints: {
                  520: {
                    slidesPerView: mbSlides,
                  },
                  768: {
                    slidesPerView: tbSlides,
                  },
                  1024: {
                    slidesPerView: ltSlides,
                  },
                  1280: {
                    slidesPerView: sdtSlides,
                  },
                  1536: {
                    slidesPerView: dtSlides,
                  },
                },
                on: {
                  init: function () {
                    
                    $(section).removeAttr('x-swiper');
                  },
                }
            });
        } catch (e) {
            console.log('Swiper JS is not defined');
            console.log(e);
        }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-old"] && !Shopify.designMode) return;
  try {
    
  if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', function () {
      if (event.target.classList.contains('swiper-slide')) {
        const slideshowSwiperEl = event.target.closest('.swiper.hero-swiper');
        let slideIndex = event.target.dataset.swiperSlideIndex;
        if (slideshowSwiperEl) {
          slideshowSwiperEl.swiper.slideToLoop(slideIndex);
        }
      }
    });
    document.addEventListener('shopify:inspector:activate', function () {
      const inspectorSlideshows = document.querySelectorAll('.hero-swiper');
      for (let i = 0; i < inspectorSlideshows.length; i++) {
        const inspectorSlideshow = inspectorSlideshows[i];
        if (inspectorSlideshow.classList.contains('autoplay')) {
          inspectorSlideshow.swiper.autoplay.stop();
          const inspectorSlidshowToggle = inspectorSlideshow.querySelector('.autoplay-toggle');
          if (inspectorSlidshowToggle) {
            inspectorSlidshowToggle.querySelector('.pause-icon').classList.add('ic-display-none');
            inspectorSlidshowToggle.querySelector('.play-icon').classList.remove('ic-display-none');
          }
        }
      }
      document.addEventListener('shopify:section:load', stopAutoplay);
    });
    document.addEventListener('shopify:inspector:deactivate', function () {
      const inspectorSlideshows = document.querySelectorAll('.hero-swiper');
      for (let i = 0; i < inspectorSlideshows.length; i++) {
        const inspectorSlideshow = inspectorSlideshows[i];
        const inspectorSlidshowToggle = inspectorSlideshow.querySelector('.autoplay-toggle');
        if (inspectorSlideshow.classList.contains('autoplay') && !inspectorSlidshowToggle) {
          inspectorSlideshow.swiper.autoplay.start();
        }
      }
      document.removeEventListener('shopify:section:load', stopAutoplay);
    });

    function stopAutoplay(target) {
      if (target) {
        const targetSlideshow = target.target.querySelector('.hero-swiper');
        if (targetSlideshow) {
          if (targetSlideshow.classList.contains('autoplay')) {
            targetSlideshow.swiper.autoplay.stop();
            const targetSlideshowToggle = targetSlideshow.querySelector('.autoplay-toggle');
            if (targetSlideshowToggle) {
              targetSlideshowToggle.querySelector('.pause-icon').classList.add('ic-display-none');
              targetSlideshowToggle.querySelector('.play-icon').classList.remove('ic-display-none');
            }
          }
        }
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
// First DOMContentLoaded event for Swiper initialization
document.addEventListener('DOMContentLoaded', function() {
  if (!Shopify.designMode) {
    var swiper = new Swiper('#{{ section.id }}_slideShow', {
  allowTouchMove: false,
  allowSlideNext: false,
  allowSlidePrev: false,
  slidesPerView: 1,
  loop: false,
  loopedSlides: 0,  // This can help prevent automatic slide cloning
  navigation: {
    nextEl: null,
    prevEl: null
  },
  pagination: {
    el: null
  },
  on: {
    init: function() {
      this.loopDestroy(); // Ensures no loop is active
      this.update();
    }
  }
});
  }
});

// Second DOMContentLoaded event for video handling and additional Swiper configurations
document.addEventListener('DOMContentLoaded', function() {
  var videos = document.querySelectorAll('.video-content');
  
  videos.forEach(function(video) {
    video.addEventListener('canplay', function() {
      video.play();
      video.classList.add('loaded');
      var previewImage = video.closest('.video-wrapper').querySelector('.preview-image');
      if (previewImage) {
        previewImage.classList.add('hidden'); // Add the hidden class to make the preview image fade out
      }
    }, { once: true });
    video.load();
  });

  // Optionally, you can add a time limit for when to show the video if metadata doesn't load
  setTimeout(function() {
    videos.forEach(function(video) {
      if (!video.classList.contains('loaded')) {
        video.classList.add('loaded'); // Force show video after some time
      }
    });
  }, 10000); // 10 seconds delay

  if (!Shopify.designMode) {
    var swiper = document.querySelector('#{{ section.id }}_slideShow');
    if (swiper) {
      swiper = swiper.swiper;
      // If loop is accidentally enabled, disable it
      if (swiper.params.loop) {
        swiper.loopDestroy();
        swiper.update();
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  let vedio_count = document.querySelectorAll('.video-section');
  for (i = 0; i < vedio_count.length; i++) {
    let section_id = vedio_count[i].dataset.id;
    let button = document.querySelector('#video-section-btn-' + section_id);
    let template = document.querySelector('#template-' + section_id).content;
    let targetDiv = document.querySelector('#video-' + section_id);
    let deferred_media = document.querySelector('#deferred-media-' + section_id);

    button.addEventListener('click', function () {
      let clonedTemplate = template.cloneNode(true);
      targetDiv.appendChild(clonedTemplate);
      deferred_media.setAttribute('loaded', true);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
